let update_value = (actionData) => {
    let $el = $(actionData.selector);
    $el.val(actionData.value);
};
export default update_value;